
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Passed props`}</h2>
    <p>{`If the styled target is a simple element (e.g. `}<inlineCode parentName="p">{`styled.div`}</inlineCode>{`), styled-components passes through any known HTML attribute to the DOM. If it is a custom React component (e.g. `}<inlineCode parentName="p">{`styled(MyComponent)`}</inlineCode>{`), styled-components passes through all props.`}</p>
    <p>{`This example shows how all props of the Input component are passed on to the
DOM node that is mounted, as with React elements.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`// Create an Input component that'll render an <input> tag with some styles
const Input = styled.input\`
  padding: 0.5em;
  margin: 0.5em;
  color: \${props => props.inputColor || "palevioletred"};
  background: papayawhip;
  border: none;
  border-radius: 3px;
\`;

// Render a styled text input with the standard input color, and one with a custom input color
render(
  <div>
    <Input defaultValue="@probablyup" type="text" />
    <Input defaultValue="@geelen" type="text" inputColor="rebeccapurple" />
  </div>
);
`}</code></pre>
    <p>{`Note how the `}<inlineCode parentName="p">{`inputColor`}</inlineCode>{` prop is not passed to the DOM, but `}<inlineCode parentName="p">{`type`}</inlineCode>{` and `}<inlineCode parentName="p">{`defaultValue`}</inlineCode>{` are. That is styled-components being smart enough to filter non-standard attributes automatically for you.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;